import { render, staticRenderFns } from "./UserActivityBarSettings.vue?vue&type=template&id=4018999c"
import script from "./UserActivityBarSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserActivityBarSettings.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports